import { Card, CardActionArea, CardContent } from "@mui/material";
import { useStyles } from "../../Search.styles";
import { determineReceiveType } from "../../../../util/receiveTypeMapping";

type ManualReceiveResultCardProps = {
	invoiceType?: string;
	recType?: string;
	purchaseOrderNumber?: string;
	invoiceNumber?: string;
	searchDataSource?: string;
	onSelect: (determinedReceiveType: string | null) => Promise<void> | void;
	message: string;
};
export const ManualReceiveResultCard = ({ invoiceType, recType, purchaseOrderNumber, invoiceNumber, searchDataSource, onSelect, message }: ManualReceiveResultCardProps) => {
	const classes = useStyles();

	const determinedReceiveType = determineReceiveType(
		invoiceType,
		recType,
		purchaseOrderNumber,
		invoiceNumber,
		searchDataSource
	);

	return (
		<Card variant="outlined" square className={classes.manualReceiveCard}>
			<CardActionArea onClick={() => onSelect(determinedReceiveType)}>
				<CardContent className={classes.manualReceiveCardContent}>
					<strong>Note:</strong> {message} <u>Start scanning</u>.
				</CardContent>
			</CardActionArea>
		</Card>
	);
};
